import { render } from "./SimpleWithLogo.vue?vue&type=template&id=4f646258"
import script from "./SimpleWithLogo.vue?vue&type=script&lang=js"
export * from "./SimpleWithLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__